module.exports = __webpack_public_path__ + "img/10.261fa4e4.png";